import React, { useState, useEffect } from 'react';
import { CQMasterDataStore } from '../../../../store/cq-master-data.store';
import GridTemplateConfigurationController from '../grid-template-config.controller';
import { CQAppConstant } from '../../../../app-constants';
import { observer } from 'mobx-react';
import { IFieldData } from '../../component-level-fields/component-field';
interface IProps {
    key ? : string;
    updateViewSourceComponentConfig: Function;
    selectedTemplateName: string;
    fieldInfo ? : IFieldData;
}

const SORT_ORDER_1 = ['ASC', 'DESC '];
const SORT_ORDER_2 = ['NULLS FIRST', 'NULLS LAST'];
const templateConfigCtrl = new GridTemplateConfigurationController();

const GridSortType = (props: IProps) => {
    const [selectedSortType1, setSelectedSortType1] = useState<string>('');
    const [selectedSortType2, setSelectedSortType2] = useState<string>('');
    const [sortOrder, setSortOrder] = useState<string>(CQMasterDataStore.OutputConfig.getStoreKeyData(props.selectedTemplateName, 'sortOrder'));

    useEffect(() => {
        const viewSourceComponentConfig = CQMasterDataStore.GridObject.gridComponentConfigView;
        if(!(Object.keys(viewSourceComponentConfig).length > 0)) {
            setSelectedSortType1(SORT_ORDER_1[0]);
            setSelectedSortType2(SORT_ORDER_2[1]);
            setSortOrder(`${SORT_ORDER_1[0]} ${SORT_ORDER_2[1]}`);
            return;
        }

        const { selectedSortType1, selectedSortType2 } = viewSourceComponentConfig;

        if(selectedSortType1) {
            setSelectedSortType1(selectedSortType1);
        } 
        else {
            setSelectedSortType1(SORT_ORDER_1[0]);
        }

        if(selectedSortType2) {
            setSelectedSortType2(selectedSortType2);
        } 
        else {
            setSelectedSortType2(SORT_ORDER_2[1]);
        }
    }, []);

    useEffect(() => {
        templateConfigCtrl.updateFieldValue('sortOrder', sortOrder, props.selectedTemplateName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sortOrder]);

    const onSortType1Change = (selectedSortType: string) => {
        let sortOrder = ''
        if (selectedSortType2) {
            sortOrder = `${selectedSortType} ${selectedSortType2}`
        } else {
            sortOrder = `${selectedSortType}`
        }
        props.updateViewSourceComponentConfig('selectedSortType1', selectedSortType);
        setSelectedSortType1(selectedSortType);
        setSortOrder(sortOrder);
    }

    const onSortType2Change = (selectedSortType: string) => {
        let sortOrder = ''
        if (selectedSortType1) {
            sortOrder = `${selectedSortType1} ${selectedSortType}`
        } else {
            sortOrder = `${selectedSortType}`
        }
        props.updateViewSourceComponentConfig('selectedSortType2', selectedSortType);
        setSelectedSortType2(selectedSortType);
        setSortOrder(sortOrder);
    }

    return (
        <div className="slds-grid slds-gutters_small" key= {props.key}>
            <div className="slds-col">
                <fieldset className="slds-form-element slds-grid slds-grid_vertical">
                    <legend className="slds-form-element__legend slds-form-element__label">{props?.fieldInfo?.name}</legend>
                    <div className="slds-grid slds-grid_align-spread">
                        <div className="slds-form-element__control">
                            {
                                SORT_ORDER_1.map((sortType: string , index:number) => {
                                    return <span className="slds-radio" key={`${sortType}${index}`}onClick={() => onSortType1Change(sortType)}>
                                        <input type="radio" id={sortType} value={selectedSortType1} name={sortType} checked={selectedSortType1 === sortType} />
                                        <label className="slds-radio__label">
                                            <span className="slds-radio_faux"></span>
                                            <span className="slds-form-element__label">{sortType}</span>
                                        </label>
                                    </span>
                                })
                            }
                        </div>
                        <div className="slds-form-element__control">
                            {
                                SORT_ORDER_2.map((sortType: string,index:number) => {
                                    return <span key={`${sortType}${index}`} className="slds-radio" onClick={() => onSortType2Change(sortType)}>
                                        <input type="radio" id={sortType} value={selectedSortType2} name={sortType} checked={selectedSortType2 === sortType} />
                                        <label className="slds-radio__label">
                                            <span className="slds-radio_faux"></span>
                                            <span className="slds-form-element__label">{sortType}</span>
                                        </label>
                                    </span>
                                })
                            }
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
    )
}

export const GridComponentSortType = observer(GridSortType);